import Alpine from "alpinejs"

Alpine.data('SearchFilter', (items) => ({
    open: false,
    searchValue: '',
    searchableItems: null,
    matchingItems: null,
    noResults: false,
    noResultsEl: null,
    activeIndex: -1,
    activeItems: null,
    init(){
        this.searchableItems = Array.from(items).map(el => {
            return {
                title: el.title,
                slug: el.slug
            }
        });

        this.options = this.$refs.listItems.children;

        this.noResultsEl = this.$el.querySelector('[data-no-results]');
    },
    updateSearch(){
        this.activeIndex = -1;
        this.clearActiveIndex();

        if(this.searchValue.length == 0){
            this.open = false;
        } else {
            this.open = true;

            this.matchingItems = this.searchableItems.filter((item) => {
                let el = this.$refs[item.slug];
                let checkbox = el.querySelector('input');

                if(item.title.includes(this.searchValue)){
                    return true;
                } 
            });

            if(this.matchingItems.length < 1){
                this.noResults = true;

            } else {
                this.noResults = false
            }

            
        }
        this.showResults();
    },
    showResults(){
        Array.from(this.searchableItems).forEach(item => {
            let el = this.$refs[item.slug];
            let checkbox = el.querySelector('input');
            let matches = this.matchingItems.some(obj => obj.slug == item.slug);
            
            if(matches && el.classList.contains('hidden') && !checkbox.checked){
                el.classList.remove('hidden');
            } else if((!matches && !el.classList.contains('hidden')) || (checkbox.checked && !el.classList.contains('hidden'))) {
                el.classList.add('hidden');
            }
        });

        if(this.noResults){
            this.noResultsEl.classList.remove('hidden')
        } 
    },
    selectItem(){
        if (this.activeIndex >= 0){
            let selectedOption = this.activeItems[this.activeIndex];
            
            let optionInput = selectedOption.querySelector('input');
            
            optionInput.click();
        }
        this.open = false;
        this.searchValue = '';
        this.updateSearch();
        
    },
    searchItem(){
        let matchingItem = this.searchableItems.find((item) => {
            if(item.title == this.searchValue){
                return true;
            }
        });
        let checkbox = null
        
        if(matchingItem){
            checkbox = this.$refs[matchingItem.slug].querySelector('input');
        } else {
            checkbox = this.noResultsEl.querySelector('input');
        }

        checkbox.checked = true;   
        
        checkbox.dispatchEvent(new Event('change'));    
        this.open = false;
        this.searchValue = '';
    },
    moveActive(direction){
        this.activeItems = Array.from(this.$refs.listItems.children).filter(child => {
            return child.offsetParent !== null;
        });


        if(direction == 'prev' && this.activeIndex >= 0){
            this.activeIndex--;
        } else if (direction == 'next' && this.activeIndex != this.matchingItems.length - 1){
            this.activeIndex++;
        } else {
            return;
        }

        this.clearActiveIndex()
        
        if(this.activeIndex >= 0){
            let selectedElement = this.activeItems[this.activeIndex];
            selectedElement.classList.add('bg-primary-100');
        }
    },
    clearActiveIndex(){
        this.searchableItems.forEach((item) => {
            if(this.$refs[item.slug].classList.contains('bg-primary-100')){
                this.$refs[item.slug].classList.remove('bg-primary-100');
            }
        })
    }
}));